import { gql } from "graphql-request";

export const ADMIN_EXPORT_USER_WORKSPACES = gql`
  query AdminExportUserWorkspaces($userId: ID!) {
    adminExportUserWorkspaces(userId: $userId)
  }
`;
